export type ClientEventType = "page_view" | "click" | "share_click";

type ClientAnalyticsEvent = {
  eventType: ClientEventType;
  linkSlug?: string;
  path: string;
  referrer?: string;
  screen?: {
    width: number;
    height: number;
  };
  utm?: Record<string, string | null>;
};

let pageViewSent = false;

function getClientContext(eventType: ClientEventType, linkSlug?: string): ClientAnalyticsEvent {
  const url = new URL(window.location.href);

  return {
    eventType,
    linkSlug,
    path: `${url.pathname}${url.search}`,
    referrer: document.referrer || undefined,
    screen: {
      width: window.screen.width,
      height: window.screen.height
    },
    utm: {
      utmSource: url.searchParams.get("utm_source"),
      utmMedium: url.searchParams.get("utm_medium"),
      utmCampaign: url.searchParams.get("utm_campaign"),
      utmContent: url.searchParams.get("utm_content"),
      utmTerm: url.searchParams.get("utm_term")
    }
  };
}

function sendEvent(event: ClientAnalyticsEvent): void {
  if (import.meta.env.DEV && window.location.port === "5173") return;

  const body = JSON.stringify(event);

  if ("sendBeacon" in navigator) {
    const blob = new Blob([body], { type: "application/json" });
    navigator.sendBeacon("/api/events", blob);
    return;
  }

  void fetch("/api/events", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body,
    keepalive: true
  }).catch(() => undefined);
}

export function trackPageView(): void {
  if (pageViewSent) return;
  pageViewSent = true;
  sendEvent(getClientContext("page_view"));
}

export function trackShareClick(linkSlug: string): void {
  sendEvent(getClientContext("share_click", linkSlug));
}

export function trackLinkClick(linkSlug: string): void {
  sendEvent(getClientContext("click", linkSlug));
}
